// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.set.from.js
// module id = ./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.set.from.js
// module chunks = 0